/**
 * Hook for RTL support in components
 */
import {useLanguageCriteria} from '@progyny/store/languageStore'

/**
 * Hook that provides RTL state
 * @returns Object with RTL state
 */
export const useRTL = () => {
  const {isRTL, direction, defaultLanguage} = useLanguageCriteria()

  return {
    // RTL state
    isRTL,
    direction,
    language: defaultLanguage,
  }
}

export default useRTL
